module.exports = __webpack_public_path__ + "static/media/icon-medicament.72bc5953.svg";